// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--1CE6v","post":"blog-module--post--oYMJm","blogPostMeta":"blog-module--blog-post-meta--3CTn3"};